import { render, staticRenderFns } from "./RequestDocuments.vue?vue&type=template&id=b2c59242&scoped=true&"
import script from "./RequestDocuments.vue?vue&type=script&lang=js&"
export * from "./RequestDocuments.vue?vue&type=script&lang=js&"
import style0 from "./RequestDocuments.vue?vue&type=style&index=0&id=b2c59242&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c59242",
  null
  
)

export default component.exports